import { APP_INITIALIZER, NgModule } from '@angular/core';
import { OpSharedModule } from "core-app/shared/shared.module";
import { OpenprojectWorkPackagesModule } from "core-app/features/work-packages/openproject-work-packages.module";
import { DisplayFieldService } from 'core-app/shared/components/fields/display/display-field.service';
import { TagsDisplayField } from './components/tags-display-field.module';

function initializeDisplayFields(displayFieldService:DisplayFieldService) {
  return () => {
    displayFieldService.addFieldType(TagsDisplayField, 'tags', ['[]Tag'])
  }
}

@NgModule({
  imports: [
    OpSharedModule,
    OpenprojectWorkPackagesModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDisplayFields,
      deps: [DisplayFieldService],
      multi: true,
    },
  ],
})
export class PluginModule {
}
